import { useAction } from '@src/redux/hooks/useAction';
import { useSelect } from '@src/redux/hooks/useSelect';
import { toggleMyAccount } from './actions';

const headerMenuSelector = (state) => {
  return state.headerMenu;
};

export const useHeaderMenu = {
  state: () => {
    return useSelect(headerMenuSelector);
  },
  actions: () => {
    return {
      toggleMyAccount: useAction(toggleMyAccount),
    };
  },
};
